import React from 'react';

import { Card, CardContent, CardHeader, cardContentClasses, Typography } from '@mui/material';
import _ from 'es-toolkit/compat';

import { Nullable } from '@clearverify/types';

import { DemoPrivacyText } from 'src/components/demoPrivacyMode';
import { SxProp } from 'src/types/mui';

import { cardStyles } from './styles';

interface BaseInboxItemCardProps {
  isSelected: boolean;
  onClick: () => void;
  avatar: React.ReactNode;
  title: React.ReactNode;
  subheader: Nullable<string> | string[];
  lastActivity?: Nullable<string>;
}

export const BaseInboxItemCard: React.FC<React.PropsWithChildren<BaseInboxItemCardProps>> = ({
  avatar,
  title,
  isSelected,
  onClick,
  subheader,
  lastActivity,
  children,
}) => {
  return (
    <Card data-e2e-element="inbox-card" sx={cardStyles(isSelected)} onClick={onClick}>
      <CardHeader
        avatar={avatar}
        title={title}
        subheader={
          <Typography variant="body2">
            {_.isArray(subheader) ? renderArraySubheader(subheader) : subheader}
          </Typography>
        }
        sx={cardHeaderStyles}
      />
      {children && (
        <CardContent
          sx={{
            paddingY: '0',
            [`&.${cardContentClasses.root}:last-child`]: {
              paddingBottom: '16px',
            },
          }}
        >
          <Typography
            whiteSpace="pre-line"
            variant="body3"
            sx={theme => ({ color: theme.palette.text.secondary })}
          >
            {lastActivity ? <DemoPrivacyText>{lastActivity}</DemoPrivacyText> : null}
          </Typography>
          {children}
        </CardContent>
      )}
    </Card>
  );
};

const cardHeaderStyles: SxProp = {
  '.MuiCardHeader-content': {
    overflow: 'hidden',
  },
};

const renderArraySubheader = (subheader: string[]) => {
  return subheader.reduce((acc, currentTitle) => {
    const convertedTitle = currentTitle.split('_').join(' ');
    return `${acc}\n${convertedTitle}`;
  }, '');
};
